import { create } from 'zustand';

interface ACHFormData {
  accountHolderName: string;
  routingNumber: string;
  accountNumber: string;
  accountNumberConfirm: string;
  address: {
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
  isAddressComplete: boolean;
}

type PaymentState = {
  paymentMethodId: string | null;
  paymentToken: string | null;
  contractSignatureName: string;
  achFormData: ACHFormData;
  isPaymentInitialized: boolean;
  setPaymentMethodId: (token: string) => void;
  setPaymentToken: (token: string) => void;
  setContractSignatureName: (name: string) => void;
  resetContractSignatureName: () => void;
  setACHFormData: (data: Partial<ACHFormData>) => void;
  resetACHFormData: () => void;
  resetPaymentMethodId: () => void;
  setPaymentInitialized: (value: boolean) => void;
};

const defaultACHFormData: ACHFormData = {
  accountHolderName: '', // 'John Doe',
  routingNumber: '', // '110000000',
  accountNumber: '', // '000123456789',
  accountNumberConfirm: '', // '000123456789',
  address: {
    line1: '', // '495 Brickell Ave',
    line2: '', // 'Apt 4009',
    city: '', // 'Miami',
    state: '', // 'FL',
    postal_code: '', // '33131',
    country: '', // 'US',
  },
  isAddressComplete: true,
};

export const usePaymentStore = create<PaymentState>((set) => ({
  paymentToken: null,
  achFormData: defaultACHFormData,
  paymentMethodId: null,
  contractSignatureName: '',
  isPaymentInitialized: false,
  setPaymentToken: (paymentToken: string) => set({ paymentToken }),
  setContractSignatureName: (contractSignatureName: string) =>
    set({ contractSignatureName }),
  resetContractSignatureName: () => set({ contractSignatureName: '' }),
  setACHFormData: (data: Partial<ACHFormData>) =>
    set((state) => ({
      achFormData: { ...state.achFormData, ...data },
    })),
  resetACHFormData: () => set({ achFormData: defaultACHFormData }),
  setPaymentMethodId: (paymentMethodId: string) => set({ paymentMethodId }),
  resetPaymentMethodId: () => set({ paymentMethodId: null }),
  setPaymentInitialized: (value: boolean) =>
    set({ isPaymentInitialized: value }),
}));
